<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="page-header">
      <div class="page-title">添加MSO</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <div class="pagemain">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" label-position="left">
        <div class="form-group">
          <div class="form-group-content">
            <div class="mm-row-block">
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>MSO信息</h3>
                </div>
                <div class="form-isheader-group-content">
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="MSO名稱" prop="name">
                        <el-input v-model="form.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
									<div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="LOGO">
									 			<uploadimage  :imageUrlList.sync="form.upload_list" listType="picture-card" :fileDir="'logo'" :watermark="false"></uploadimage>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="字體顏色" prop="color">
                        <el-color-picker v-model="form.color"></el-color-picker>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="背景顏色" prop="background">
                        <el-color-picker v-model="form.background"></el-color-picker>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="創立時間" prop="opentime">
                        <el-date-picker v-model="form.opentime" type="date" placeholder="選擇日期">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="mm-row">
                    <div class="mm-col">
                      <el-form-item label="狀態">
                        <el-switch v-model="form.status" active-text="啟用" inactive-text="禁用">
                        </el-switch>
                      </el-form-item>

                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="form-submit">
          <el-button @click="formsubmit('form')" type="primary">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadimage from "@/components/Uploadimage.vue"
export default {
  components: {
    uploadimage
  },
  data () {
    return {
      loading: false,
      form: {
        color: '#333',
        background: '#fff',
				status: true,
				upload_list:[]
      },
      rules: {

        name: [{
          required: true,
          message: '請填寫MSO名稱',
        }, {
          pattern: /^[\S]+$/,
          message: '只能輸入可見字符'
        }],
        opentime: [{

          required: true,
          message: '請選擇創立時間',

        }]


      }
    };
  },
  methods: {
    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.loading = true;
					let data = this.form;
          this.post('/api/mso/addsave', {
            data: data
          }).then((res) => {

            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '添加MSO成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            } else {
              this.$message({
                showClose: true,
                message: '添加MSO失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    }
  },
  created () {

  }

};
</script>
<style scoped>
.mm-row {
  width: 50%;
}
</style>
